import { MouseEventHandler } from "react"
import { Box, IconButton, Tooltip } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendarDays } from "@fortawesome/pro-light-svg-icons"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    button: {
        padding: ".75rem",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: ".75rem",
        color: theme.palette.common.black,
        backgroundColor: theme.palette.common.white,
        width: "2.5rem",
        height: "2.5rem",
    },
    buttonActive: {
        border: `1px solid ${theme.palette.common.white}`,
        color: theme.palette.common.white,
        backgroundColor: theme.palette.common.black,
        "&:hover": {
            backgroundColor: theme.palette.tailwind.slate[800],
        },
    },
}))

type StandardCalendarButtonProps = Readonly<{
    isActive: boolean
    onClick: MouseEventHandler<HTMLButtonElement>
}>

export function StandardCalendarButton({ isActive, onClick }: StandardCalendarButtonProps) {
    const { classes, cx } = useStyles()

    return (
        <LocalizedStrict id="calendar-button-show-calendar" attrs={{ title: true }}>
            <Tooltip title="Show calendar">
                <Box component="span">
                    <LocalizedStrict id="calendar-button-show-calendar" attrs={{ "aria-label": true }}>
                        <IconButton
                            className={cx(classes.button, isActive && classes.buttonActive)}
                            onClick={onClick}
                            aria-label="Show calendar"
                        >
                            <FontAwesomeIcon icon={faCalendarDays} size="xs" />
                        </IconButton>
                    </LocalizedStrict>
                </Box>
            </Tooltip>
        </LocalizedStrict>
    )
}
